import { Reveal } from "@/components/bits";

const PORTRAIT = "https://customer-assets.emergentagent.com/job_critica-argentina/artifacts/v1magjkw_Aldun_21.jpg";

const BADGES = ["Profesora en Letras · UBA", "Maestranda en Estudios Literarios", "Lectora obsesiva"];

export default function SobreMi() {
  return (
    <section id="sobre-mi" data-testid="sobre-mi-section" className="bg-ink py-20 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal className="self-start">
            <div className="relative">
              <div className="absolute -left-3 -top-3 h-full w-full border border-crimson/50" aria-hidden="true" />
              <img
                src={PORTRAIT}
                alt="Aldana Sol — guía del programa"
                data-testid="sobre-mi-portrait"
                className="relative aspect-[4/5] w-full object-cover"
              />
            </div>
            <p className="mt-6 flex items-center gap-4 text-[10px] font-medium uppercase tracking-[0.3em] text-ash">
              <span className="h-px w-8 bg-crimson/70" /> Buenos Aires · Argentina
            </p>
          </Reveal>

          <Reveal delay={0.15} className="self-center">
            <p className="flex items-center gap-4 text-[11px] font-medium uppercase tracking-[0.3em] text-gold">
              <span className="h-px w-10 bg-gold/60" /> Sobre mí
            </p>
            <h2 className="mt-8 font-serif text-3xl leading-[1.12] tracking-tight text-cream sm:text-4xl lg:text-5xl">
              ¡Hola! Soy <span className="font-semibold not-italic text-gold">Aldana Sol</span>
            </h2>
            <p className="mt-8 text-sm font-light leading-relaxed text-bone/85 sm:text-base">
              Lectora y amante de la literatura en <span className="font-semibold not-italic text-gold">todas sus formas</span>. Profesora en
              Letras por la <strong className="font-normal text-cream">UBA</strong>, y Maestranda en Estudios
              Literarios (UBA · FFyL).
            </p>
            <p className="mt-5 text-sm font-light leading-relaxed text-bone/85 sm:text-base">
              Me entusiasma armar un círculo íntimo de lectoras que disfruten de leer y quieran volverse{" "}
              <span className="font-semibold not-italic text-gold">absolutamente profundas y afiladas</span> en su mirada para sumergirnos juntas
              en el universo hermoso de estas cuatro autoras fundamentales de nuestra literatura nacional.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              {BADGES.map((b) => (
                <span
                  key={b}
                  data-testid={`sobre-mi-badge-${b.slice(0, 8).replace(/\s/g, "-").toLowerCase()}`}
                  className="border border-cream/20 px-4 py-2 text-[10px] font-medium uppercase tracking-[0.22em] text-bone/80"
                >
                  {b}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
